import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyBar() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-209" data-mp="nx45j6nvnyv4">
      {show && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-sand bg-cream/95 px-4 py-3 shadow-[0_-8px_24px_rgba(67,50,56,0.08)] backdrop-blur-md sm:hidden" data-id="element-210" data-mp="ny5so9i64bt7">
          <div className="flex items-center justify-between gap-3" data-id="element-211" data-mp="299xg82aml1eu">
            <div className="leading-tight" data-id="element-212" data-mp="2995wppuayu4x">
              <div className="text-xs text-muted line-through" data-id="element-213" data-mp="24acj7xf0n34r">$69.990</div>
              <div className="font-serif text-xl font-semibold text-sage-deep" data-id="element-214" data-mp="2491cboq9xf9f">
                Hoy $27.990
              </div>
            </div>
            <a href="https://yoga-360.impultienda.ar/checkout" className="rounded-full bg-clay px-6 py-3 text-sm font-semibold text-cream" data-id="element-215" data-mp="3mhn6qnx1mdo9">
              Comprar ahora
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}